import {
  StyledSessionList
} from '../VsBattlePopup/VsBattlePopup.styled';
import { useTokenAuth } from '../../hooks';
import { AppContext } from '../../providers/AppContext';
import { Avatar, BroadsiderHudPopup, IconButton, SelectableButton } from '../';
import { theme } from '../../theme';
import { getStats } from '../../providers/BasejumpApiProvider';
import { useContext, useEffect, useState } from 'react';
import { BROADSIDER_OG_CONTRACT_ADDRESS } from '../../constants';
import { useAudio } from '../../providers/AudioContext';
import {
  CloseButtonSection,
  PointsPopupContent,
  PointsMapContainer,
  PointsStatsContainer,
  BoostLine,  
  PointsAvatarsHolder,
  PointsInventoryHolder,
  PointsInventoryTabHeader,
  PointsInventoryTab,
  PointsInventoryIcon,
  PointsInventoryContent,
  PointsInventoryControls,
  PointsInventoryPanel,
  PointsInventoryItem,
  PointsInventoryItemImage,
  StyledPointsInventory,
  StyledPointsStats,
  StyledPointsStatNames,
  StyledPointsStatValues,
  StyledStatWidget,
  StatWidgetImage,
  StatWidgetFullLayout,
  StatWidgetReducedLayout,
  StatWidgetValue,
  StatWidgetFullTitle,
  StatWidgetMainTitle,
  StatWidgetSecondaryTitle,
  StatWidgetReducedTitle,
  StatWidgetTitleValue,
  StatsContainer
} from './PointsPopup.styled';

import {
  PopupHeaderStart,
  PopupHeaderEnd,
  PopupHeaderTitle,
  PopupHeader
} from '../PopupHeader/PopupHeader.styled';

const BoostTitle = ({ children, boost = 0 }) => {
  return (
    <PopupHeader>
      <PopupHeaderStart/>
      <PopupHeaderTitle>
        {children}
      </PopupHeaderTitle>
      <PopupHeaderEnd />
      <PopupHeaderTitle>
        <BoostLine>
          Boost:&nbsp;
          <span className='highlight'>{boost}%</span>
        </BoostLine>
      </PopupHeaderTitle>
      <PopupHeaderStart/>
    </PopupHeader>
  );
};

const InventoryItem = ({ item }) => {
  return (
    <PointsInventoryItem style={{ background: theme.baseGreen }}>
      <PointsInventoryItemImage src={'/assets/item_bg.png'}/>
      <PointsInventoryItemImage src={item.getImgSource()}/>
    </PointsInventoryItem>
  );
};
const PointsInventory = ({ inventoryItems }) => {
  const { playSFX } = useAudio();
  const { setShowPointsPopup, setShowShop } = useContext(AppContext);
  const categories = {
    'weapon': { icon: '/assets/points_weapon.svg', objects: [] },
    'armor': { icon: '/assets/points_armour.svg', objects: [] },
    'object': { icon: '/assets/points_objects.svg', objects: [] },
  };
  const [selectedCategory, setSelectedCategory] = useState('weapon');
  inventoryItems.forEach((i) => {
    categories[i.getType()].objects.push(i);
  });

  return (
    <StyledPointsInventory>
      <PointsInventoryContent>
        <PointsInventoryTabHeader>
          {Object.keys(categories).map((k) => <PointsInventoryTab onMouseEnter={() => playSFX('hover')} onClick={() => { playSFX('button'); setSelectedCategory(k); }} $selected={selectedCategory === k}><PointsInventoryIcon src={categories[k].icon}/></PointsInventoryTab>)}
        </PointsInventoryTabHeader>
        <PointsInventoryPanel>
          {categories[selectedCategory].objects.map((i) => <InventoryItem item={i}/>)}
        </PointsInventoryPanel>
      </PointsInventoryContent>
      <PointsInventoryControls>
        <IconButton
	  onClick={() => {
            setShowShop(true);
            setShowPointsPopup(false);
	  }}
          backgroundOverwrite={theme.buttonGreen}
          backgroundOverwriteHover={theme.buttonLightGreen}
          borderOverwrite='rgba(0, 0, 0, .16)'>
          + Add Action Items
        </IconButton>
      </PointsInventoryControls>
    </StyledPointsInventory>
  );
}

const PointsStats = ({ avgPointsDaily, avgXpDaily }) => {
  return (
    <StyledPointsStats>
      <StyledPointsStatNames>
        <div className='green bold'>Avg Bones Per Day:</div>
        <div className='blue'>Avg XP Per Day:</div>
      </StyledPointsStatNames>
      <StyledPointsStatValues>
        <div className='green bold'>{avgPointsDaily}<img src='/assets/points_smile.svg'/></div>
        <div className='blue'>{avgXpDaily}</div>
      </StyledPointsStatValues>
    </StyledPointsStats>
  );
};

const StatWidget = ({ value, image, mainTitle, secondaryTitle }) => {
  return (
    <StyledStatWidget $align='start'>
      <StatWidgetImage src={image} />
      <StatWidgetFullLayout>
        <StatWidgetValue>{value}</StatWidgetValue>
        <StatWidgetFullTitle>
          <StatWidgetMainTitle>{mainTitle}</StatWidgetMainTitle>
          <StatWidgetSecondaryTitle>{secondaryTitle}</StatWidgetSecondaryTitle>
        </StatWidgetFullTitle>
      </StatWidgetFullLayout>
    </StyledStatWidget>
  );
};

const StatWidget2 = ({ value, image, title }) => {
  return (
    <StyledStatWidget $align='start'>
      <StatWidgetImage src={image} />
      <StatWidgetFullLayout>
        <StatWidgetFullTitle>
          <StatWidgetSecondaryTitle>{title}</StatWidgetSecondaryTitle>
          <StatWidgetTitleValue>{value}</StatWidgetTitleValue>
        </StatWidgetFullTitle>
      </StatWidgetFullLayout>
    </StyledStatWidget>
  );
};

const StatWidget3 = ({ value, title }) => {
  return (
    <StyledStatWidget $align='end'>
      <StatWidgetReducedLayout>
        <StatWidgetReducedTitle $color={theme.pointsGreen}>{title}</StatWidgetReducedTitle>
        <StatWidgetValue $color={theme.pointsGreen}>{value}</StatWidgetValue>
      </StatWidgetReducedLayout>
    </StyledStatWidget>
  );
};

const getDaysSince = (isoTimestamp) => {
  const timestampDate = new Date(isoTimestamp);
  const now = new Date();
  const differenceMs = now.getTime() - timestampDate.getTime();
  const daysDifference = differenceMs / (1000 * 60 * 60 * 24);
  return Math.floor(daysDifference) || 1;
}

const PointsPopup = () => {
  const { inventoryItems: items, ownedBroadsiders: avatars, selectBroadsider, setShowPointsPopup, selectedBroadsider } = useContext(AppContext);
  const [hoveredBroadsider, setHoveredBroadsider] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);
  const ownedBroadsiders = avatars.filter(a => a.getContractAddress() === BROADSIDER_OG_CONTRACT_ADDRESS);
  const inventoryItems = items.filter((item) => {
    if (!item.getEffects().includes('FOOD')) {
      return true;
    }
    if (!['common', 'uncommon'].includes(item.getRarity())) {
      return true;
    }
    return false;
  });
  const hoveredId = hoveredBroadsider ? hoveredBroadsider.getId() : null;
  const onSelectAvatar = (avatar) => {
    setShowPointsPopup(false);
    selectBroadsider(avatar);
  };
  const { basejumpToken, user } = useTokenAuth();
  const [userStats, setUserStats] = useState({
    current_xp: 0,
    current_points: 0,
    total_xp: 0,
    total_points: 0,
    weekly_xp: 0,
    weekly_points: 0,
    multipliers: {
      collecton_edition_count: 0,
      collecton_edition_multiplier: 0,
      collecton_edition_value: 0,
      first_edition_count: 0,
      first_edition_multiplier: 0,
      first_edition_value: 0,
      items_count: 0,
      items_multiplier: 0,
      ogs_count: 0,
      ogs_multiplier: 0,
      ogs_value: 0,
      vips_count: 0,
      vips_multiplier: 0,
      vips_value: 0
    }
  });

  const avgXpDaily = Math.floor(userStats.total_xp / getDaysSince(user.created_at));
  const avgPointsDaily = Math.floor(userStats.total_points / getDaysSince(user.created_at));

  const itemsMultiplier = userStats.multipliers?.items_multiplier || 0;
  const ogsMultiplier = (userStats.multipliers?.ogs_multiplier || 0) + (userStats.multipliers?.vips_multiplier || 0);
  const booksMultiplier = (userStats.multipliers?.first_edition_multiplier || 0)
    + (userStats.multipliers?.collecton_edition_multiplier || 0);
  const totalNftMultiplier = ogsMultiplier + booksMultiplier;
  const totalMultiplier = totalNftMultiplier + itemsMultiplier;

  const fetchUserStats = async () => {
    setStatsLoading(true);
    try {
      const stats = await getStats(basejumpToken);
      setUserStats(stats);
    } finally {
      setStatsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserStats();
  }, []);
  return (
    <BroadsiderHudPopup overwrightWidth={`calc(100vw - 2 * ${theme.frameOffset})`}>
      <PointsPopupContent onClick={(e) => e.stopPropagation()}>
        <PointsStatsContainer>
          <StyledSessionList style={{paddingTop: '0', gap: '0.5rem', overflowY: 'auto'}}>
	  {/*<BoostTitle boost={ogsMultiplier}>
              <BoostLine>
                <span className='highlight'>{ownedBroadsiders.length}:&nbsp;</span>
                  Broadside OG
                <span className='thin'>&nbsp;Squad Members</span>
              </BoostLine>
            </BoostTitle>
            <BoostTitle boost={itemsMultiplier}>
              <BoostLine>
                <span className='highlight'>{inventoryItems.length}:&nbsp;</span>
                  Action Items
                <span className='thin'>&nbsp;Inventory</span>
              </BoostLine>
            </BoostTitle>*/}
            <StatsContainer>
              <StatWidget value={`${userStats.weekly_xp}`} mainTitle="xp" secondaryTitle="this week" image="/assets/points.svg"/>
              <StatWidget2 value={`${userStats.total_xp}`} title="total xp earned" image="/assets/points.svg"/>
              <StatWidget3 value={`${totalMultiplier}%`} title="total boost"/>
              <StatWidget value={`${userStats.weekly_points}`} mainTitle="Bones" secondaryTitle="this week" image="/assets/coin_low.gif"/>
              <StatWidget2 value={`${userStats.total_points}`} title="total bones earned" image="/assets/coin_low.gif"/>
              <StatWidget3 value={`${itemsMultiplier}%`} title="items boost"/>
              <StatWidget value={`${(userStats.multipliers?.ogs_count || 0) + (userStats.multipliers?.vips_count || 0)}`} mainTitle="OG" secondaryTitle="crew members" image="/assets/skull.svg"/>
              <StatWidget2 value={`${avgXpDaily}`} title="avg xp daily" image="/assets/points.svg"/>
              <StatWidget3 value={`${ogsMultiplier}%`} title="og boost"/>
              <StatWidget value={`${userStats.multipliers?.first_edition_count || 0}`} mainTitle="Broadside Book" secondaryTitle="First Edition" image="/assets/first_edition.gif"/>
              <StatWidget value={`${userStats.multipliers?.collecton_edition_count || 0}`} mainTitle="Broadside Book" secondaryTitle="Collectors Edition" image="/assets/collection_edition.gif"/>
              <StatWidget3 value={`${booksMultiplier}%`} title="books boost"/>
              <StatWidget value={`${userStats.multipliers?.items_count || 0}`} mainTitle="Inventory" secondaryTitle="action items" image="/assets/skull.svg"/>
              <StatWidget2 value={`${avgPointsDaily}`} title="avg bones daily" image="/assets/coin_low.gif"/>
            </StatsContainer>
	  </StyledSessionList>
        </PointsStatsContainer>
        <PointsMapContainer>
          <PointsAvatarsHolder>
            {ownedBroadsiders.map((f, index) => (<Avatar onMouseEnter={() => setHoveredBroadsider(f)} key={'selec' + index} figure={f} isSelected={f.getId() === selectedBroadsider.getId()} onClick={onSelectAvatar} isHovered={hoveredId === f.getId()}/>))}
          </PointsAvatarsHolder>
          <PointsInventoryHolder>
            <PointsInventory inventoryItems={inventoryItems}/>
          </PointsInventoryHolder>
          <CloseButtonSection>
	    <SelectableButton selected={false} isIconButton={true} onClick={() => setShowPointsPopup(false)} imgHover={null} img='/assets/close.svg' />
          </CloseButtonSection>
        </PointsMapContainer>
      </PointsPopupContent>
    </BroadsiderHudPopup>
  );
};

export default PointsPopup;
